import React, { useState } from "react";
import { Box } from "@mui/material";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import RotateLeftTwoToneIcon from "@mui/icons-material/RotateLeftTwoTone";
import RotateRightTwoToneIcon from "@mui/icons-material/RotateRightTwoTone";
import AutorenewOutlinedIcon from "@mui/icons-material/AutorenewOutlined";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import { styled } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import TuneIcon from "@mui/icons-material/Tune";
import "./mapData.scss";

const styles = {
  margin: 0,
  fontSize: "10px",
  color: "#202020",
};
const StyledSpeedDial = styled(SpeedDial)(({ theme }) => ({
  position: "absolute",
  "&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft": {
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  "&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight": {
    top: theme.spacing(1),
    left: theme.spacing(-2),
  },
}));

const MapToolBar = ({
  zoom,
  onClickZoom,
  rotateClick,
  fitToScreenClick,
  onClickChangeOrientation,
}) => {
  const [open, setOpen] = useState(false); // Track the state of the menu

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const actions = [
    {
      icon: (
        <ZoomOutIcon
          className="cursorPointer"
          color={zoom <= 1 ? "disabled" : "inherit"}
        />
      ),
      name: "Zoom Out",
      onClick: () => {
        if (zoom > 1) {
          onClickZoom("out");
        }
      },
    },
    {
      icon: (
        <h6 style={{ ...styles }}>{zoom <= 1 ? 0 : parseInt(zoom * 10)}%</h6>
      ),
      name: "Zoom Level",
    },
    {
      icon: (
        <ZoomInIcon
          className="cursorPointer"
          color={zoom >= 10 ? "disabled" : "inherit"}
        />
      ),
      name: "Zoom In",
      onClick: () => {
        if (zoom < 10) {
          onClickZoom("in");
        }
      },
    },

    {
      icon: <RotateRightTwoToneIcon className="cursorPointer" />,
      name: "Rotate Right",
      onClick: () => rotateClick("right"),
    },
    {
      icon: <AutorenewOutlinedIcon className="cursorPointer" />,
      name: "Refresh",
      onClick: () => fitToScreenClick(),
    },

    {
      icon: <RotateLeftTwoToneIcon className="cursorPointer" />,
      name: "Rotate Left",
      onClick: () => rotateClick("left"),
    },

    {
      icon: <TuneIcon className="cursorPointer" />,
      name: "Adjust boundary",
      onClick: () => onClickChangeOrientation && onClickChangeOrientation(),
    },
  ];

  return (
    <Box className="mapTool-Wrap">
      <StyledSpeedDial
        ariaLabel="SpeedDial playground example"
        icon={<MenuIcon />}
        direction={"down"}
        open={open}
        onClick={handleOpen}
        onClose={handleClose}
        FabProps={{
          sx: {
            margin: "2px !important",
            bgcolor: "transparent !important", // Change the background color to transparent
            "&:hover": {
              bgcolor: "rgb(229, 34, 34)",
            },
          },
        }}
      >
        {actions.map((action) => {
          return (
            <SpeedDialAction
              className="MapToolSpeedAction"
              sx={{
                ...(action?.name === "Zoom Level" && { cursor: "not-allowed" }),
              }}
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              onClick={(e) => {
                if (action.onClick) {
                  e.stopPropagation();
                  action.onClick(e);
                }
              }}
              FabProps={{
                sx: {
                  width: "60px",
                  "&:hover": {
                    bgcolor: "white",
                  },
                },
              }}
            />
          );
        })}
      </StyledSpeedDial>
    </Box>
  );
};

export default MapToolBar;
